"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find-index.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _interface = require("../interface");
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../../_utils/hooks/usePrefixCls");
var _excluded = ["size", "color", "className", "style"]; // GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DirectionTopIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('icon');
  var size = props.size,
    color = props.color,
    className = props.className,
    customStyle = props.style,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var isFontSize = false;
  var isSize = false;
  if (typeof size === 'number') {
    isFontSize = true;
  } else {
    isSize = _interface.SizeTypes.findIndex(function (item) {
      return item === size;
    }) !== -1;
  }
  var classes = (0, _classnames.default)(prefixCls, prefixCls + '--' + 'arrow-top', (0, _defineProperty2.default)({}, 'size-' + size, isSize), className);
  var style = _objectSpread({
    color: color,
    fontSize: isFontSize ? size : undefined
  }, customStyle);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    id: "caret-up",
    role: "img",
    "aria-label": "arrowup",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    ref: ref,
    className: classes,
    style: style
  }, restProps, {
    version: "1.1"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 4.66663L12 11L4 11L8 4.66663Z",
    fill: "currentColor",
    "fill-opacity": "0.9"
  })));
});
var _default = exports.default = DirectionTopIcon;